/**
 * 客户端相关处理
 */
import useragent from '@common/useragent'
import cookieKit from '../lib/cookie-kit'
import SuishoujiClient from '../client/suishouji'
import SuiguanjiaClient from '../client/suiguanjia'
import CardniuClient from '../client/cardniu'

let clientData = null

// 获取客户端信息
export const getClientData = async () => {
  if (!clientData) {
    let clientInfo = null
    try {
      if (useragent.isSuishouji) {
        clientInfo = await (new SuishoujiClient()).getClientInfo()
      } else if (useragent.isSuiguanjia) {
        clientInfo = await (new SuiguanjiaClient()).getClientInfo()
      } else if (useragent.isKaniu) {
        clientInfo = await (new CardniuClient()).getClientInfo()
      }
    } catch (error) {
      console.error('获取客户端信息失败, Error:', error)
    }
    clientData = {
      appName: clientInfo ? clientInfo.appName : '',
      appVersion: clientInfo ? clientInfo.appVersion : '',
      channel: clientInfo ? clientInfo.channel : '',
      udid: clientInfo ? clientInfo.udid : '',
      idfa: clientInfo ? clientInfo.idfa : '',
    }
  }
  // HIT: 为了兼容旧版本的数据上报，这里设置一个cookie
  if (clientData.channel) {
    cookieKit.set('app_parterCode', clientData.channel)
  }
  if (clientData.appName) {
    cookieKit.set('app_appName', clientData.appName)
  }
  if (clientData.appVersion) {
    cookieKit.set('app_appVersion', clientData.appVersion)
  }

  return clientData
}

// 为了以后扩展，将getClientData单独抽取出来
export default {
  getClientData
}


// WEBPACK FOOTER //
// ./node_modules/@finance/ssvue/node_modules/@common/collect/src/data/data_client.js